import { apiV2EzvizStreamUrlPost } from '@maxtropy/device-customer-apis-v2';
import { AccessMode, ConfigType } from '../type';

export const isEzopenUrl = (url?: string) => !!url && /^ezopen:\/\//i.test(url);

export const shouldResolveEzvizUrl = (params: {
  accessMode?: number;
  configType?: number;
  url?: string;
  deviceId?: string | number;
}) => {
  const { accessMode, configType, url, deviceId } = params;
  return (
    accessMode === AccessMode.YSY && deviceId != null && (configType === ConfigType.PROXY || !url || isEzopenUrl(url))
  );
};

export const getEzvizTranscodeUrl = async (id?: string | number) => {
  if (id == null) {
    return undefined;
  }

  const res = await apiV2EzvizStreamUrlPost({ id });
  return res?.liveUrlTranscode;
};
